export const districtScreenerIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#schoolFilter',
    intro: 'Select a school from the dropdown to view WordFlight usage data for that school.',
  },
  {
    element: '#printButton',
    intro: 'Click here to print the Screener School Report.'
  },
  {
    element: '.report',
    intro: 'Screener is where you can find overview information on the WordFlight Screener. You can see the Screener enrollment, completion, and results at the school level. You can also see the percentage of students who have completed the Screener sorted by teacher.'
  },
  {
    element: '#district-report-screener-enrollment',
    intro: 'See your school’s Screener enrollment data. See how many students are enrolled in the WordFlight Screener.'
  },
  {
    element: '#district-report-screener-completion',
    intro: 'See the percentage of students who have completed the WordFlight Screener.'
  },
  {
    element: '#district-report-screener-performance',
    intro: 'See the percentage of students and number of students in each risk category. The WordFlight Screener sorts students into three risk categories: High Risk, Some Risk, and Proficient.'
  },
  {
    element: '#school-report',
    intro: 'Click the plus sign to view WordFlight Screener data sorted by school. See the school name, number of teachers, number of WordFlight students, and the percentage of students who have completed the WordFlight Screener for the selected school.'
  },
  {
    element: '#teacher-report',
    intro: 'Click the plus sign to view WordFlight Screener data sorted by teacher. See the teacher’s name, the grades they teach, their school, and the percentage of their students who have completed the WordFlight Screener.'
  }
];
